import React, { useEffect, useState } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import PageSectionAboutHero from 'components/page/sections/page-section-about-hero';

export const IncognitoModeHeroBlockContainer: React.FC = () => {
  const isMobile = useMediaQuery(MediaQueryWidth['desktop-sm']);

  const [imageUrl, setImageUrl] = useState(
    `${CdnImagePath}/landing/assets/photos/features/incognito-mode/incognito-mode-hero-landscape.jpg`,
  );

  useEffect(() => {
    if (isMobile) {
      setImageUrl(
        `${CdnImagePath}/landing/assets/photos/features/incognito-mode/incognito-mode-hero-portrait.jpg`,
      );
    } else {
      setImageUrl(
        `${CdnImagePath}/landing/assets/photos/features/incognito-mode/incognito-mode-hero-landscape.jpg`,
      );
    }
  }, [isMobile]);

  const props = {
    title: features.incognitoMode.lxIncognitoModeHeroTitle,
    imageSrc: imageUrl,
    objectPosition: '50% 33%',
    subTitle: features.incognitoMode.lxIncognitoModeHeroSubtitle,
  };

  return (
    <PageSectionAboutHero
      image={{
        src: props.imageSrc,
        objectPosition: props.objectPosition,
        hasLoadPriority: true,
      }}
      title={props.title}
      subtitle={props.subTitle}
      color="peach"
    />
  );
};
